import { useQuery } from '../useQuery/useQuery'
import { useAuth } from '../useAuth/useAuth'

import { getPartnerAllowlistedVolunteeringCountries } from '@percent/workplace-giving/api/auth/getPartnerAllowlistedVolunteeringCountries/getPartnerAllowlistedVolunteeringCountries'

export const useAllowlistedVolunteeringCountries = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { state } = useAuth()

  const { data: allowlistedCountryCodes, isLoading: isAllowlistedCountriesLoading } = useQuery(
    ['getPartnerAllowlistedVolunteeringCountries'],
    getPartnerAllowlistedVolunteeringCountries,
    {
      enabled: enabled && state.status === 'authorized',
      staleTime: 1000 * 60 * 5
    }
  )

  return {
    allowlistedCountryCodes: allowlistedCountryCodes ?? [],
    isAllowlistedCountriesLoading
  }
}
